export const enum MmamaEntityType {
  DROPDOWN = 'DROPDOWN',
  MULTISELECT = 'MULTISELECT',
  TEXT = 'TEXT',
  HEADING = 'HEADING'
}
